// isProduction can be used to check if we are in production at run-time.
//
// non-www requests are redirected to www. so it should be enough.
//
// `For build-time checks we use `process.env.NODE_ENV === "production"`. The build-time
// checks can be used for code that we want to eliminate in the production builds.
export const isProduction =
  window.location.hostname === 'www.storebrand.no' ||
  window.location.hostname === 'www.intra.storebrand.no' || // internal advisor host
  window.location.hostname === 'pr.stb.intra'; // old internal advisor host

export const isTest =
  window.location.hostname === 'www-t.storebrand.no' ||
  window.location.hostname === 'www-t.intra.storebrand.no';

export const isTestTS = window.location.hostname === 'www-ts.storebrand.no';

export const isLocal = window.location.hostname === 'localhost';

export const isTestOrLocal = isTest || isLocal;

export const isAdvisorMode =
  window.location.hostname.includes('.intra.storebrand.no') || // internal advisor host
  window.location.hostname.includes('.stb.intra') || // old internal advisor host
  (window.location.hostname === 'localhost' &&
    window.localStorage.getItem('forceAdvisorMode') === 'true');

export const keycloakLogoutRedirectURI = isProduction
  ? 'https://www.storebrand.no/infosider/utlogget/'
  : '';

export const getEnvironment = () => {
  if (isProduction) return 'prod';
  if (isTest) return 'test';
  return 'local';
};
